"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ActivityColor = exports.ACTIVITY_NAMES = exports.Activity = void 0;
/** Enumeration of field activities */
var Activity;
(function (Activity) {
    Activity["Planting"] = "activity-planting";
    Activity["Fertilizer"] = "activity-fertilizer";
    Activity["CropProtection"] = "activity-crop-protection";
    Activity["Irrigation"] = "activity-irrigation";
    Activity["Harvest"] = "activity-harvest";
    Activity["Tillage"] = "activity-tillage";
    Activity["Grazing"] = "activity-grazing";
})(Activity = exports.Activity || (exports.Activity = {}));
/** Names of activites, mostly for iteration/testing purposes */
exports.ACTIVITY_NAMES = [
    "Planting",
    "Fertilizer",
    "CropProtection",
    "Irrigation",
    "Harvest",
    "Tillage",
    "Grazing",
];
/** Mapping of activity name to color */
exports.ActivityColor = {
    Planting: "#9CC368",
    Fertilizer: "#EA9048",
    CropProtection: "#EECC4E",
    Irrigation: "#65AAD7",
    Harvest: "#BC893E",
    Tillage: "#BC893E",
    Grazing: "#EA9048",
};
